import styled from "styled-components";

export const Heading = styled.h1`
	font-size: 26px;
	text-align: center;
	margin: 0;
	margin-bottom: 30px;
`;

export const BlogListWrapper = styled.section`
	section.blog-items {
		margin-bottom: 40px;
	}
`;
